import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";

import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

import { postSchedule, putSchedule, getMBMAVOBBoxs } from "services/ConfigServices";
import styled from "styled-components";

import { typeData, lightStateData, destinationData } from "variables/MBM/lists/schedule";
import DefaultWeekEventDialog from "./DefaultWeekEventDialog";
import CalendarEventDialog from "./CalendarEventDialog";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid' // a plugin!
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import "./schedules.css";
import CustomConfirmationDialog from "components/CustomDialog/CustomConfirmationDialog";
import { scheduletext } from "variables/MBM/schedule";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function ScheduleDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const { closeModal, refetch, setLoading, setNotification, currentSchedule } = props;
  const [openDefaultWeekEvent, setOpenDefaultWeekEvent] = useState(false);
  const [openCalendarEvent, setOpenCalendarEvent] = useState(false);
  const [type, setType] = useState(currentSchedule?.parameters?.type || "light");
  const [typetoconfirm, setTypetoconfirm] = useState("");
  const [typechangeopen, setTypechangeopen] = useState(false);
  const [name, setName] = useState(currentSchedule?.parameters?.name || "");
  const [description, setDescription] = useState(currentSchedule?.parameters?.description || "");
  const [destinationtype, setDestinationtype] = useState(currentSchedule?.destination?.destinationtype || "avobbox");
  const [avobboxs, setAvobboxs] = useState(currentSchedule?.destination?.avobboxs || []);
  const [groups, setGroups] = useState(currentSchedule?.groupid ? "" + currentSchedule.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [boxdata, setBoxdata] = useState([]);

  const [editedevent, setEditedevent] = useState("");

  const [defaultweekevents, setDefaultweekevents] = useState(currentSchedule?.defaultweekevents || []);
  const [defaultweekeventsdisplay, setDefaultweekeventsdisplay] = useState([]);
  const [calendarevents, setCalendarevents] = useState(currentSchedule?.calendarevents || []);
  const [calendareventsdisplay, setCalendareventsdisplay] = useState([]);

  const handleTypeChange = (event) => {
    if (defaultweekevents.length > 0 || calendarevents.length > 0) {
      setTypetoconfirm(event.target.value);
      setTypechangeopen(true);
    }
    else {
      setType(event.target.value);
    }
  };
  const applyChangeType = () => {
    setTypechangeopen(false);
    setDefaultweekevents([]);
    setCalendarevents([]);
    setType(typetoconfirm);
    setTypetoconfirm("");
  }
  const denyChangeType = () => {
    setTypechangeopen(false);
    setTypetoconfirm("");
  }

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const handleDestinationtypeChange = (event) => {
    setDestinationtype(event.target.value);
  };
  const selectedBox = () => {
    let selected = boxdata.filter((obj) =>
      avobboxs.includes(obj.id));
    return selected;
  };
  const handleBoxsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setAvobboxs(newArray);
  };


  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpenDefaultWeekEvent = () => {
    setOpenDefaultWeekEvent(true);
  };
  const handleEditCloseDefaultWeekEvent = () => {
    setOpenDefaultWeekEvent(false);
  };
  const handleClickOpenCalendarEvent = () => {
    setOpenCalendarEvent(true);
  };
  const handleEditCloseCalendarEvent = () => {
    setOpenCalendarEvent(false);
  };


  const handleSubmit = (event) => {
    if (currentSchedule)
      updateSchedule(event);
    else
      createSchedule(event);
    //setLoading(true);
    closeModal();
  };

  useEffect(() => {
    if (!name || !groups || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  useEffect(() => {
    if (groups) {
      axios
        .get(
          getMBMAVOBBoxs(groups),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let filteredavobboxs = res.data.avobboxs?.filter((obj) => obj.type === 3);
          let tmpBoxsData = filteredavobboxs.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setBoxdata(tmpBoxsData || []);
          console.log(tmpBoxsData);
        });
    }
  }, [groups]);

  //default week calendar display
  useEffect(() => {
    const tmpdisplayevents = defaultweekevents.map((event) => {
      let displayedevent = {};
      displayedevent.id = event.id;
      if (type === "light") {
        displayedevent.title = event.name + " (" + lightStateData.find((x) => x.id == event.value)?.name + ")";
        displayedevent.color = lightStateData.find((x) => x.id == event.value)?.color;
        displayedevent.textColor = lightStateData.find((x) => x.id == event.value)?.textColor;
      }
      else if (type === "temperature") {
        displayedevent.title = event.name + " (" + event.value + " °C)";
        if (event.value < 24) {
          displayedevent.textColor = "#000000";
          if (event.value < 10)
            displayedevent.color = "#DEECFF";
          else if (event.value < 16)
            displayedevent.color = "#85ABFF";
          else if (event.value < 18)
            displayedevent.color = "#00DFD7";
          else if (event.value < 20)
            displayedevent.color = "#10D081";
          else if (event.value < 22)
            displayedevent.color = "#E5EB85";
          else
            displayedevent.color = "#FF6B54";
        }
        else {
          displayedevent.textColor = "#FFFFFF";
          displayedevent.color = "#FF6B54";
        }
      }
      else
        displayedevent.title = event.name + " (" + event.value + ")";
      let nowdate = moment();
      let timearray = event.startTime.split(':');
      let hours = Number(timearray[0]);
      let minutes = Number(timearray[1]);
      nowdate.set('day', event.startDay);
      nowdate.set('hour', hours);
      nowdate.set('minute', minutes);
      nowdate.set('second', 0);
      if (event.startDay === 0)
        nowdate.add(7, 'day');
      displayedevent.start = nowdate.format("YYYY-MM-DD HH:mm:ss");

      nowdate = moment();
      timearray = event.endTime.split(':');
      hours = Number(timearray[0]);
      minutes = Number(timearray[1]);
      nowdate.set('day', event.endDay);
      nowdate.set('hour', hours);
      nowdate.set('minute', minutes);
      nowdate.set('second', 0);
      if (event.endDay === 0)
        nowdate.add(7, 'day');
      displayedevent.end = nowdate.format("YYYY-MM-DD HH:mm:ss");
      return displayedevent;
    });
    setDefaultweekeventsdisplay(tmpdisplayevents);
  }, [defaultweekevents, defaultweekevents.length, openDefaultWeekEvent]);

  //default exception calendar display
  useEffect(() => {
    console.log(defaultweekevents);
    const tmpdisplayevents = calendarevents.map((event) => {
      let displayedevent = {};
      displayedevent.id = event.id;
      if (type === "light") {
        displayedevent.title = event.name + " (" + lightStateData.find((x) => x.id == event.value)?.name + ")";
        displayedevent.color = lightStateData.find((x) => x.id == event.value)?.color;
        displayedevent.textColor = lightStateData.find((x) => x.id == event.value)?.textColor;
      }
      else if (type === "temperature") {
        displayedevent.title = event.name + " (" + event.value + " °C)";
        if (event.value < 24) {
          displayedevent.textColor = "#000000";
          if (event.value < 10)
            displayedevent.color = "#DEECFF";
          else if (event.value < 16)
            displayedevent.color = "#85ABFF";
          else if (event.value < 18)
            displayedevent.color = "#00DFD7";
          else if (event.value < 20)
            displayedevent.color = "#10D081";
          else if (event.value < 22)
            displayedevent.color = "#E5EB85";
          else
            displayedevent.color = "#FF6B54";
        }
        else {
          displayedevent.textColor = "#FFFFFF";
          displayedevent.color = "#FF6B54";
        }
      }
      else
        displayedevent.title = event.name + " (" + event.value + ")";
      displayedevent.start = event.startDay + " " + event.startTime + ":00";
      displayedevent.end = event.endDay + " " + event.endTime + ":00";
      return displayedevent;
    });
    setCalendareventsdisplay(tmpdisplayevents);
  }, [calendarevents, calendarevents.length, openCalendarEvent]);

  const timeformat = (hours, minute) => {
    let formated = new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(hours);
    formated += ":";
    formated += new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(minute);
    return formated;
  }
  const handleSelectTimeDefaultWeek = (event) => {
    let newevent = {};
    newevent.name = "";
    newevent.startDay = event.start.getDay();
    newevent.endDay = event.end.getDay();
    newevent.startTime = timeformat(event.start.getHours(), event.start.getMinutes());
    newevent.endTime = timeformat(event.end.getHours(), event.end.getMinutes());
    newevent.value = "";
    setEditedevent(newevent);
    handleClickOpenDefaultWeekEvent();
  }
  const handleSelectEventDefaultWeek = (event) => {
    let editedevent = defaultweekevents.find((o) => o.id === event.event.id);
    setEditedevent({ ...editedevent });
    handleClickOpenDefaultWeekEvent();
  }
  const handleSelectTimeCalendar = (event) => {
    let startdatestr = event.startStr;
    if (startdatestr.includes("T"))
      startdatestr = startdatestr.substring(0, startdatestr.indexOf("T"));
    let enddatestr = event.endStr;
    if (enddatestr.includes("T"))
      enddatestr = enddatestr.substring(0, enddatestr.indexOf("T"));

    let newevent = {};
    newevent.name = "";
    newevent.startDay = startdatestr;
    newevent.endDay = enddatestr;
    newevent.startTime = timeformat(event.start.getHours(), event.start.getMinutes());
    newevent.endTime = timeformat(event.end.getHours(), event.end.getMinutes());
    newevent.value = "";
    setEditedevent(newevent);
    handleClickOpenCalendarEvent();
  }
  const handleSelectEventCalendar = (event) => {
    let editedevent = calendarevents.find((o) => o.id === event.event.id);
    setEditedevent({ ...editedevent });
    handleClickOpenCalendarEvent();
  }

  const createSchedule = async (event) => {
    const parameters = {
      name,
      type,
      description,
    }
    const destination = {
      destinationtype,
      avobboxs,
      avobboxsupdate: avobboxs,
    }
    axios
      .post(
        postSchedule(),
        {
          parameters,
          groups,
          defaultweekevents,
          calendarevents,
          destination,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Planning créée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateSchedule = async (event) => {
    const parameters = {
      ...currentSchedule.parameters,
      name,
      type,
      description,
    }
    const destination = {
      ...currentSchedule.destination,
      destinationtype,
      avobboxs,
      avobboxsupdate: avobboxs,
    }
    axios
      .put(
        putSchedule(currentSchedule.id),
        {
          parameters,
          groups,
          defaultweekevents,
          calendarevents,
          destination,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Planning modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>
      <TabContext value={value} className={classes.root}>
        <div className={classes.demo2}>
          <AppBar
            position="static"
            className={classes.demo3}
            style={{ boxShadow: "none", shadowColor: "red" }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              scrollButtons="auto"
            >
              <StyledTab label="Paramètres généraux" value="0" />
              <StyledTab label="Planning hebdomadaire" value="1" />
              <StyledTab label="Calendrier d'exceptions" value="2" />

              {/* <StyledTab label="Dérogations" value="3" /> */}

            </StyledTabs>
            <Typography className={classes.padding} />
          </AppBar>
          <Divider variant="fullWidth" />
          <TabPanel value="0">
            <form className={classes.root}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={7} lg={7}>
                  <div>
                    <CustomSelect
                      inputTitle={"Type"}
                      selectValue={type}
                      handleSelectValueChange={handleTypeChange}
                      data={typeData}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={"Nom"}
                      textInput={name}
                      handleTextInputChange={handleNameChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={"Description"}
                      textInput={description}
                      handleTextInputChange={handleDescriptionChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <CustomSelect
                      inputTitle={"Destination"}
                      selectValue={destinationtype}
                      handleSelectValueChange={handleDestinationtypeChange}
                      data={destinationData}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <AutocompleteMultiselectInputById
                      specialWidth={"97%"}
                      inputMargin={"1rem 0rem 0rem"}
                      inputTitle={"AVOB Box concernées"}
                      selected={selectedBox()}
                      list={boxdata}
                      handleChange={handleBoxsChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} lg={5}>
                  <div
                    className={classes.treeVisible}
                  >
                    <TreeLabel>Choix du périmètre</TreeLabel>
                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={setGroups}
                        userSelectedIds={groups}
                        disabled={!mbm_geb_control_schedules}
                      />
                    </ImageList>
                  </div>
                </GridItem>
              </GridContainer>
            </form>
          </TabPanel>
          <TabPanel value="1">
            <FullCalendar
              plugins={[timeGridPlugin, interactionPlugin]}
              locales={[frLocale]}
              locale='fr'
              initialView="timeGridWeek"
              height="60vh"
              selectable={mbm_geb_control_schedules}
              scrollTimeReset={false}
              select={handleSelectTimeDefaultWeek}
              eventClick={handleSelectEventDefaultWeek}
              dayHeaderFormat={{
                weekday: 'long'
              }}
              headerToolbar={false}
              views={{
                timeGrid: {
                  allDaySlot: false
                }
              }}
              events={defaultweekeventsdisplay}
            />
          </TabPanel>
          <TabPanel value="2">
            <FullCalendar
              plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
              locales={[frLocale]}
              locale='fr'
              height="60vh"
              selectable={mbm_geb_control_schedules}
              scrollTimeReset={false}
              initialView="dayGridMonth"
              headerToolbar={{
                start: 'today prev,next',
                center: 'title',
                end: 'dayGridMonth timeGridWeek'
              }}
              select={handleSelectTimeCalendar}
              eventClick={handleSelectEventCalendar}
              views={{
                timeGrid: {
                  allDaySlot: false
                }
              }}
              events={calendareventsdisplay}
            />
          </TabPanel>
          {/* <TabPanel value="3">

          </TabPanel> */}
        </div>
        {mbm_geb_control_schedules ?
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
            }
            onClick={() => {
              handleSubmit();
            }}
          >
            Enregistrer
          </Button> : <></>
        }
      </TabContext>
      <Dialog
        onClose={handleEditCloseDefaultWeekEvent}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openDefaultWeekEvent}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseDefaultWeekEvent}>
          Evènement
        </CustomDialogTitle>
        <DialogContent dividers>
          <DefaultWeekEventDialog
            closeModal={handleEditCloseDefaultWeekEvent}
            editedevent={editedevent}
            scheduletype={type}
            existingevents={defaultweekevents}
            setExistingevents={setDefaultweekevents}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloseCalendarEvent}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openCalendarEvent}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseCalendarEvent}>
          Evènement
        </CustomDialogTitle>
        <DialogContent dividers>
          <CalendarEventDialog
            closeModal={handleEditCloseCalendarEvent}
            editedevent={editedevent}
            scheduletype={type}
            existingevents={calendarevents}
            setExistingevents={setCalendarevents}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        open={typechangeopen}
        dialogContent={scheduletext.changetypeconfirmationtext}
        handleExit={applyChangeType}
        handleClose={denyChangeType}
      />
    </>
  );
}

export default ScheduleDialog;
